import { BonusCondition, ConditionMode, Currency } from '@synergy/models';
import { FormattedNumber } from 'react-intl';
import { ModeFormattedNumber } from '@synergy/components-next';
import { TableCell } from '@mui/material';

interface BonusConditionTableCellFooterProps {
    bonusCondition: BonusCondition;
    defaultCurrency: Currency;
    revenue?: number;
    value: number;
    locale: string;
}

export const BonusConditionTableCellFooter = ({
    bonusCondition,
    defaultCurrency,
    value,
    revenue,
}: BonusConditionTableCellFooterProps) => {
    const { id, mode, unit, currency } = bonusCondition;

    return (
        <>
            <TableCell sx={{ textAlign: 'right' }} key={id}>
                <ModeFormattedNumber value={value} mode={mode} unit={unit} currency={currency ?? defaultCurrency} />
            </TableCell>
            {mode === ConditionMode.Amount && (
                <TableCell sx={{ textAlign: 'right' }} key={`${id}-revenue`}>
                    <FormattedNumber
                        value={revenue || 0}
                        currency={currency ?? defaultCurrency}
                        style="currency"
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                    />
                </TableCell>
            )}
        </>
    );
};
